import React, { useCallback, useRef } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import { Icon } from 'mastodon/components/icon';
import { useAppHistory } from './router';
import { ChevronLeftIcon } from './icons/chevron_left';

const messages = defineMessages({
  back: { id: 'column_back_button.label', defaultMessage: 'Back' },
});

export const BackButton: React.FC<{
  onlyIcon: boolean;
  style?: string;
  isAccountHeader?: boolean;
}> = ({ onlyIcon, style, isAccountHeader = false }) => {
  const history = useAppHistory();
  const intl = useIntl();
  const isProcessingRef = useRef(false);
  const lastEventTypeRef = useRef<string | null>(null);

  const handleBackClick = useCallback(
    (e: React.TouchEvent<HTMLButtonElement> | React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      if (isProcessingRef.current) return;

      isProcessingRef.current = true;
      lastEventTypeRef.current = e.type;

      try {
        if (history.location.state?.fromMastodon && !isAccountHeader) {
          history.goBack();
        } else {
          history.replace('/');
        }
      } finally {
        setTimeout(() => {
          isProcessingRef.current = false;
          lastEventTypeRef.current = null;
        }, 100);
      }
    },
    [history]
  );

  return (
    <button
      onClick={handleBackClick}
      style={{ touchAction: 'manipulation', userSelect: 'none' }}
      className={classNames('column-header__back-button', {
        compact: onlyIcon,
      }, style)}
      aria-label={intl.formatMessage(messages.back)}
    >
      <Icon
        id='chevron-left'
        icon={ChevronLeftIcon}
        className='column-back-button__icon'
      />
      {!onlyIcon && (
        <FormattedMessage id='column_back_button.label' defaultMessage='Back' />
      )}
    </button>
  );
};